import HttpHelper from '../../helpers/httpHelper';
import { buildQueryString } from '../../helpers/utility';
require('dotenv').config();
const headerInfo = {};

// Callers historically passed a bare status string; both shapes stay supported.
const toFilter = (input) => (typeof input === "string" ? { status: input } : (input || {}));

class TransactionAPI {
    static async CreateBuyTransaction(req) {
        let url = process.env.REACT_APP_API_URL + '/swaps?code=' + req.code;
        return HttpHelper.httpRequest(url, 'POST', headerInfo, req.data);
    }

    static async CreateSellTransaction(req) {
        let url = process.env.REACT_APP_API_URL + '/swaps?code=' + req.code;
        return HttpHelper.httpRequest(url, 'POST', headerInfo, req.data);
    }

    static async CreateWithdrawTransaction(req) {
        let url = process.env.REACT_APP_API_URL + '/withdraws?code=' + req.code;
        return HttpHelper.httpRequest(url, 'POST', headerInfo, req.data);
    }

    static async UpdateWithdrawTransaction(req) {
        let url = process.env.REACT_APP_API_URL + '/withdraws/approve/' + req;
        return HttpHelper.httpRequest(url, 'PATCH', headerInfo);
    }

    static async GetBuyTransactions(query) {
        const filter = toFilter(query);
        let url = process.env.REACT_APP_API_URL + '/swaps' + buildQueryString({
            type: 'Buy',
            status: filter.status || 'Approved',
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async GetSellTransactions(query) {
        const filter = toFilter(query);
        let url = process.env.REACT_APP_API_URL + '/swaps' + buildQueryString({
            type: 'Sell',
            status: filter.status || 'Approved',
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async UpdatePlanMember(req) {
        let url = process.env.REACT_APP_API_URL + `/planmeber/update/${req.id}?amount=${req.amount}`;
        return HttpHelper.httpRequest(url, 'PUT', headerInfo);
    }

    static async GetWithdrawTransactions(query) {
        const filter = toFilter(query);
        let url = process.env.REACT_APP_API_URL + '/withdraws' + buildQueryString({
            page: filter.page,
            pageSize: filter.pageSize,
            search: filter.search,
            status: filter.status,
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async GetPayouts(query) {
        const filter = toFilter(query);
        let url = process.env.REACT_APP_API_URL + '/payouts' + buildQueryString({
            page: filter.page,
            pageSize: filter.pageSize,
            search: filter.search,
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async GetAllPayouts(query) {
        const filter = toFilter(query);
        let url = process.env.REACT_APP_API_URL + '/allpayouts' + buildQueryString({
            status: filter.status,
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async GetPlanMembers(query) {
        let url = process.env.REACT_APP_API_URL + `/member/plans?page=${query.page}&pageSize=${query.pageSize}&search=${query.search || ""}`;;
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    static async GetContracts(query) {
        let url = process.env.REACT_APP_API_URL + `/contracts?page=${query.page}&pageSize=${query.pageSize}&search=${query.search || ""}`;
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }
}

export default TransactionAPI;
